// extracted by mini-css-extract-plugin
export default {"integrationCard__button":"style-module__integrationCard__button___mJfIM"};